import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(4.000000, 2.000000)">
          <g>
            <mask id="company-mask" fill="white">
              <path d="M9.12684018,0.713068107 L14.8132186,5.49871324 C15.2083109,5.83122216 15.4363784,6.32125093 15.4363784,6.83764236 L15.4363784,16.7449826 C15.4363784,17.7114809 14.6528767,18.4949826 13.6863784,18.4949826 L2.3136216,18.4949826 C1.34712329,18.4949826 0.563621603,17.7114809 0.563621603,16.7449826 L0.563621603,6.83764236 C0.563621603,6.32125093 0.791689119,5.83122216 1.18678142,5.49871324 L6.87315982,0.713068107 C7.52441427,0.16497361 8.47558573,0.16497361 9.12684018,0.713068107 Z M7.83902283,1.86072164 L2.15264443,6.64636677 C2.09620268,6.69386805 2.0636216,6.76387216 2.0636216,6.83764236 L2.0636216,16.7449826 C2.0636216,16.8830538 2.17555042,16.9949826 2.3136216,16.9949826 L13.6863784,16.9949826 C13.8244496,16.9949826 13.9363784,16.8830538 13.9363784,16.7449826 L13.9363784,6.83764236 C13.9363784,6.76387216 13.9037973,6.69386805 13.8473556,6.64636677 L8.16097717,1.86072164 C8.06794082,1.78242243 7.93205918,1.78242243 7.83902283,1.86072164 Z M8,5.25 C9.51878306,5.25 10.75,6.48121694 10.75,8 C10.75,9.51878306 9.51878306,10.75 8,10.75 C6.48121694,10.75 5.25,9.51878306 5.25,8 C5.25,6.48121694 6.48121694,5.25 8,5.25 Z M8,6.75 C7.30964406,6.75 6.75,7.30964406 6.75,8 C6.75,8.69035594 7.30964406,9.25 8,9.25 C8.69035594,9.25 9.25,8.69035594 9.25,8 C9.25,7.30964406 8.69035594,6.75 8,6.75 Z" />
            </mask>
            <g mask="url(#company-mask)">
              <g transform="translate(-4.000000, -2.000000)">
                <rect fill="currentColor" x="0" y="0" width="24" height="24" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
